const NO_TRANSLATE = {
  className: "no-translate",
  translate: "no" as const,
} as const;

/**
 * weglotで翻訳したくない要素に付与する属性を返す
 */
export const withNoTranslate = (props?: {
  className?: string;
}): { className: string; translate: "no" } => ({
  ...NO_TRANSLATE,
  className: props?.className
    ? `no-translate ${props.className}`
    : "no-translate",
});
